import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl, intlShape } from 'react-intl';
import messages from '../../../messages';
import Section from '../../../../components/Section';
import ControlContainer from '../../../../components/ControlContainer';
import P from '../../../../../../components/P';
import CheckboxInput from './CheckboxInput';

const DeclarationSection = ({
  isReadOnly,
  declarationSignature,
  privacyActAuthorisationSignature,
  handleChange,
  intl, // eslint-disable-line no-unused-vars
}) => (
  <Section>
    <ControlContainer>
      <P style={{ fontWeight: 'bold' }}>
        <FormattedMessage {...messages.declaration} />
      </P>
      <hr style={{ height: 1, backgroundColor: 'black', border: 'none' }} />
      <P>
        <FormattedMessage {...messages.declarationText1} />
      </P>
      <P>
        <FormattedMessage {...messages.declarationText2} />
      </P>
      <li style={{ marginLeft: 40 }}>
        <FormattedMessage {...messages.declarationText3} />
      </li>
      <div className="row">
        <div className="form-group col-md-6 col-sm-9">
          <CheckboxInput
            name="declarationSignature"
            checked={declarationSignature === true}
            onChange={handleChange('form.declarationSignature')}
            disabled={isReadOnly}
            message={messages.iAgreeToTheAboveCondition}
            messageId={messages.iAgreeToTheAboveCondition.id}
          />
        </div>
      </div>
      <hr style={{ height: 1, backgroundColor: 'black', border: 'none' }} />
      <Section>
        <ControlContainer>
          <P style={{ fontWeight: 'bold' }}>
            <FormattedMessage {...messages.privacyActAuthorisation} id={messages.privacyActAuthorisation.id} />
          </P>
          <P>
            <FormattedMessage {...messages.privacyActAuthorisationText1} />
          </P>
          <P>
            <FormattedMessage {...messages.privacyActAuthorisationText2} />
          </P>
          <li style={{ marginLeft: 40 }}>
            <FormattedMessage {...messages.privacyActAuthorisationText3} />
          </li>
          <li style={{ marginLeft: 40 }}>
            <FormattedMessage {...messages.privacyActAuthorisationText4} />
          </li>
        </ControlContainer>
      </Section>
      <div className="row">
        <div className="form-group col-md-6 col-sm-9">
          <CheckboxInput
            name="privacyActAuthorisationSignature"
            checked={privacyActAuthorisationSignature === true}
            onChange={handleChange('form.privacyActAuthorisationSignature')}
            disabled={isReadOnly}
            message={messages.iAgreeToTheAboveCondition}
            messageId={messages.iAgreeToTheAboveCondition.id}
          />
        </div>
      </div>
    </ControlContainer>
  </Section>
);

DeclarationSection.propTypes = {
  isReadOnly: PropTypes.bool.isRequired,
  declarationSignature: PropTypes.bool.isRequired,
  privacyActAuthorisationSignature: PropTypes.bool.isRequired,
  handleChange: PropTypes.func.isRequired,
  intl: intlShape.isRequired,
};

export default injectIntl(DeclarationSection);



// WEBPACK FOOTER //
// ./app/containers/FastCover/StepDeclaration/components/SubmitClaim/components/DeclarationSection.js